<template>
  <b-card no-body class="balances-card">
    <div class="balances-header">
      <span class="font-weight-bold">Current Balances</span>
      <span class="text-muted" style="font-size: 10px">Available Promotions</span>
    </div>
    <div class="balances-body">
      <div
        class="text-center text-danger font-weight-bold"
        style="
          font-size: 10px;
          margin-bottom: 8px;
          background: #fff3cd;
          padding: 3px;
          border-radius: 3px;
        "
      >
        ⚠ Non-Standard bet template
      </div>
      <div class="bal-grid">
        <!-- Cash Balance — full-width, one aligned row per token -->
        <div class="bal-box cash-box">
          <div class="cash-head">
            <div class="bal-icon" style="background: #e8f5e9">
              <feather-icon
                icon="DollarSignIcon"
                size="14"
                style="color: #2e7d32"
              />
            </div>
            <span class="cash-title">Cash Balance</span>
          </div>
          <TokenBalances
            rows
            show-total
            class="cash-rows"
            :balances="
              userData.dwalletBalance ? userData.dwalletBalance.balances : []
            "
            :fallback-amount="userData.user.balance || 0"
          />
        </div>

        <!-- Deposit Matches -->
        <div class="bal-box">
          <div class="bal-icon" style="background: #e3f2fd">
            <feather-icon icon="CreditCardIcon" style="color: #1565c0" />
          </div>
          <div class="val">{{ countTotalPromo("Deposit") }}</div>
          <div class="lbl">Deposit Matches</div>
          <div class="sub">{{ countTotalPromo("Deposit") }} active</div>
        </div>

        <!-- Boosts -->
        <div class="bal-box" style="cursor: pointer" @click="showBoostModal">
          <div class="bal-icon" style="background: #fff3e0">
            <feather-icon icon="ZapIcon" style="color: #e65100" />
          </div>
          <div class="val">{{ countTotalPromo("Boost") }}</div>
          <div class="lbl">Boosts</div>
          <div class="sub">{{ countTotalPromo("Boost") }} available</div>
        </div>

        <!-- Bonus Balance -->
        <div class="bal-box">
          <div class="bal-icon" style="background: #fce4ec">
            <feather-icon icon="UploadIcon" style="color: #c62828" />
          </div>
          <div class="val">{{ formatCurrencyBuiltInFunc(availableBonus) }}</div>
          <div class="lbl">Bonus Balance</div>
        </div>

        <!-- Pending Bets -->
        <div class="bal-box">
          <div class="bal-icon" style="background: #f3e5f5">
            <feather-icon icon="ClockIcon" style="color: #7b1fa2" />
          </div>
          <div class="val">{{ userData.pendingBetStatistics.count }}</div>
          <div class="lbl">Pending Bets</div>
          <div class="sub">
            {{
              formatCurrencyBuiltInFunc(userData.pendingBetStatistics.total)
            }}
          </div>
        </div>

        <!-- Bonus Back -->
        <div class="bal-box">
          <div class="bal-icon" style="background: #e0f2f1">
            <feather-icon icon="TrendingUpIcon" style="color: #00695c" />
          </div>
          <div class="val">{{ countTotalPromo("Money Back Specials") }}</div>
          <div class="lbl">Bonus Back</div>
          <div class="sub">
            {{ countTotalPromo("Money Back Specials") }} unlocked
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { BCard } from "bootstrap-vue";
import { mapState } from "vuex";
import TokenBalances from "@/views/apps/customers/components/TokenBalances.vue";

export default {
  components: { BCard, TokenBalances },
  computed: {
    ...mapState("user/detail", ["userData"]),
    ...mapState("user/bonus", ["availableBonus"]),
  },
  methods: {
    countTotalPromo(type) {
      return (
        this.userData.promotionsAvailable?.find((i) => i.type === type)
          ?.count ?? 0
      );
    },
    showBoostModal() {
      this.$bvModal.show("boost-modal");
    },
  },
  setup() {
    return { formatCurrencyBuiltInFunc };
  },
};
</script>

<style lang="scss" scoped>
.balances-card {
  border: 1px solid #e2e6ea;
  border-radius: 6px;
  max-width: 100%;
}
.balances-header {
  background: #f8f9fa;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e6ea;
  font-size: 12px;
  font-weight: 700;
  color: #1a1f36;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.balances-body {
  padding: 8px;
}
.bal-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}
.bal-box {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px 6px;
  text-align: center;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.bal-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 6px;
}
.bal-box .val {
  font-size: 14px;
  font-weight: 700;
  color: #1a1f36;
}

/* Cash Balance — full-width box with aligned token rows */
.cash-box {
  grid-column: 1 / -1;
  text-align: left;
  padding: 8px 10px;
}
.cash-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}
.cash-head .bal-icon {
  width: 22px;
  height: 22px;
  margin: 0;
  border-radius: 5px;
}
.cash-title {
  font-size: 10px;
  font-weight: 700;
  color: #1a1f36;
}
/* fallback (no tokens): single USD value */
.cash-rows {
  font-size: 14px;
  font-weight: 700;
  color: #198754;
}
.cash-rows ::v-deep .token-row {
  font-size: 11px;
  padding: 3px 0;
  color: #1a1f36;
}
.cash-rows ::v-deep .token-row + .token-row {
  border-top: 1px dashed #e9ecef;
}
.cash-rows ::v-deep .token-fiat {
  font-size: 10px;
  font-weight: 400;
  color: #6c757d;
  text-align: right;
}
.cash-rows ::v-deep .token-total {
  border-top: 1px solid #e2e6ea;
  margin-top: 2px;
}
.cash-rows ::v-deep .token-total .token-fiat {
  font-weight: 700;
  color: #198754;
}
.bal-box .lbl {
  font-size: 9px;
  color: #666;
  margin-top: 2px;
  font-weight: 500;
}
.bal-box .sub {
  font-size: 9px;
  color: #999;
  margin-top: 1px;
}

/* When sidebar stacks to full width (≤991px), use 3 columns */
@media (max-width: 991px) {
  .bal-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
/* Mobile: back to 2 columns */
@media (max-width: 576px) {
  .bal-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
